<template lang="pug">
    el-dialog(:title=" !ruleForm.id ? '新增裁判': '修改裁判信息'" :fullscreen="false",:visible.sync='visible'  :close-on-click-modal='false' :modal-append-to-body='false')
        el-form(:model="ruleForm",:inline="false" :rules="rules", ref="ruleForm", label-width="100px", label-suffix=":", @keyup.enter.native="ruleFormSubmit()")
            el-form-item(label="姓名" prop="name")
                el-input(v-model="ruleForm.name" placeholder="请填写姓名")
            el-form-item(label="手机号码" prop="tel")
                el-input(v-model="ruleForm.tel"  placeholder="请填写手机号" maxlength='11')
            el-form-item(label="身份证号" prop="code")
                el-input(v-model="ruleForm.code"  placeholder="请填写身份证号")
            el-form-item(label="主办方" prop="orgId")
                el-select(v-model="ruleForm.orgId" placeholder="请选择主办方" filterable clearable)
                    el-option(v-for="(item,index) in sysOrgList",:key="index",:label="item.name",:value="item.orgId")
            el-form-item(label='地区')
                    el-select(v-model="ruleForm.proviceId" placeholder="请选择" @change="changeProvice")
                        el-option(v-for="(item,index) in proviceList",:key="index",:label="item.name",:value="item.proviceId")
                    font &nbsp;&nbsp;省&nbsp;&nbsp;
                    el-select(v-model="ruleForm.cityId",placeholder="请选择")
                        el-option(v-for="(item,index) in cityList",:key="index",:label="item.cityname",:value="item.cityId")
                    font &nbsp;&nbsp;市&nbsp;&nbsp;
            el-form-item(label="级别" prop="level")
                el-select(v-model="ruleForm.level" placeholder="请选择个人级别" clearable)
                    el-option(label="2.0" value="2.0")
                    el-option(label="2.5" value="2.5")
                    el-option(label="3.0" value="3.0")
                    el-option(label="3.5" value="3.5")
                    el-option(label="4.0" value="4.0")
                    el-option(label="4.5" value="4.5")
                    el-option(label="5.0" value="5.0")
            el-form-item(label="性别" prop="gender")
                el-radio(v-model="ruleForm.gender" :label="0") 男
                el-radio(v-model="ruleForm.gender" :label="1" style='margin-left:13px;') 女
            el-form-item(label="职业" prop="position")
                el-radio(v-model="ruleForm.position" :label="1") 学生
                el-radio(v-model="ruleForm.position" :label="2") 在职
            el-form-item(label="邮箱" prop="email")
                el-input(v-model="ruleForm.email" placeholder="")
            el-form-item(label="银行卡号" prop="bankid")
                el-input(v-model="ruleForm.bankid" placeholder="")
        span.dialog-footer(slot="footer")
            el-button(type="primary" @click="ruleFormSubmit()" :disabled="clickFlag") 保 存
            el-button(@click="visible=false") 返 回
</template>
<script>
import util from '@/libs/util.js'
export default {
  data () {
    return {
      sysOrgList: [],
        clickFlag: false,
      proviceList: [],
      cityList: [],
      //文件上传时授权
      ruleForm: {
        id: null,
        name: '',
        tel: '',
        code: '',
        orgId: '',
        proviceId: '',
        cityId: '',
        level: null,
        gender: null,
        position: null,
        email: '',
        bankid: ''
      },
      visible: false,
      rules: {
        name: [
          { required: true, message: '姓名不能为空!', trigger: 'blur' },
          { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
        ],
        tel: [
          { required: true, message: '手机号码不能为空！', trigger: 'blur' },
          { pattern: /^1[12345789]\d{9}$/, message: '请输入正确的手机号码' }
        ],
        code: [
          { required: true, message: '身份证号不能为空!', trigger: 'blur' },
          {
            pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
            message: '请输入正确的身份证号'
          }
        ],
        orgId: [
          { required: true, message: '主办方不能为空！', trigger: 'change' }
        ],
        gender: [
          { required: true, message: '必须选择性别!', trigger: 'change' }
        ],
        level: [
          { required: true, message: '级别不能为空!', trigger: 'change' }
        ],
        position: [
          { required: true, message: '必须选择职业！', trigger: 'change' }
        ],
        email: [
          {
            type: 'email',
            message: '请输入正确的E-mail',
            trigger: 'blur,change'
          },
            { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
        ],
        bankid: [
          { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init (id) {
        this.clickFlag = false
      this.ruleForm.id = id || null
      this.$http({
        url: this.$http.adornUrl('/sysOrg/list'),
        method: 'get',
        params: this.$http.adornParams()
      })
        .then(data => {
          this.sysOrgList = data && data.code === 0 ? data.list : []
        })
        .then(() => {
          this.$nextTick(() => {
            this.visible = true
            this.$refs['ruleForm'].resetFields()
            this.ruleForm.proviceId = ''
            this.ruleForm.cityId = ''
            this.cityList = []
          })
        })
        .then(() => {
          this.initProvice()
          if (this.ruleForm.id) {
            this.$http({
              url: this.$http.adornUrl(`/ctReferee/getId/${this.ruleForm.id}`),
              method: 'get',
              params: this.$http.adornParams()
            }).then(data => {
              if (data && data.code === 0) {
                this.ruleForm.name = data.bean.name
                this.ruleForm.tel = data.bean.tel
                this.ruleForm.code = data.bean.code
                this.ruleForm.orgId = data.bean.orgId
                this.ruleForm.proviceId = data.bean.provinceCode
                this.ruleForm.cityId = data.bean.cityCode
                this.ruleForm.level = data.bean.level
                this.ruleForm.gender = Number(data.bean.gender)
                this.ruleForm.position = Number(data.bean.position)
                this.ruleForm.email = data.bean.email
                this.ruleForm.bankid = data.bean.bankid
                this.changeProvice(0)
              }
            })
          }
        })
    },
      openFullScreen () {
          this.loading = this.$loading({
              lock: true,
              text: 'Loading',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
          })
      },
    initProvice () {
      this.$http({
        url: this.$http.adornUrl('/dicProvince/list'),
        method: 'get',
        params: this.$http.adornParams()
      }).then(data => {
        this.proviceList = data && data.code === 0 ? data.list : []
      })
    },
    changeProvice (flag) {
      if (flag != 0) {
        this.cityList = []
        this.ruleForm.cityId = ''
      }
      this.$http({
        url: this.$http.adornUrl('/dicProvinceCity/list'),
        method: 'get',
        params: this.$http.adornParams({
          proviceId: this.ruleForm.proviceId
        })
      }).then(data => {
        this.cityList = data && data.code === 0 ? data.list : []
      })
    },
    //新增方法
    ruleFormSubmit () {
      this.$refs['ruleForm'].validate(valid => {
        if (valid) {
           // this.openFullScreen()
            this.clickFlag = true
          this.$http({
            url: this.$http.adornUrl(
              `/ctReferee/${!this.ruleForm.id ? 'save' : 'update'}`
            ),
            method: 'post',
            data: {
              id: this.ruleForm.id || undefined,
              name: this.ruleForm.name,
              tel: this.ruleForm.tel,
              code: this.ruleForm.code,
              orgId: this.ruleForm.orgId,
              provinceCode: this.ruleForm.proviceId,
              cityCode: this.ruleForm.cityId,
              level: this.ruleForm.level,
              gender: this.ruleForm.gender,
              position: this.ruleForm.position,
              email: this.ruleForm.email,
              bankid: this.ruleForm.bankid
            }
          }).then(data => {
            if (data && data.code === 0) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                   // this.loading.close()
                  this.visible = false
                  this.$emit('refreshDataList')
                }
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        }
      })
    }
  }
}
</script>
